"use strict";
import { isArray } from "class-validator";
import { commonConstants } from "../_constants";

const INITIAL_SERVER_SUCCESS_MESSAGE_STATE = {
     show: false,
     messages: [],
};

export function successMessageReducer(
     state = INITIAL_SERVER_SUCCESS_MESSAGE_STATE,
     action,
) {
     switch (action.type) {
          case commonConstants.AJAX_SUCCESS:
               return {
                    show: true,
                    messages: [...state.messages, action.payload],
               };

          case commonConstants.HIDE_AJAX_SUCCESS:
               return INITIAL_SERVER_SUCCESS_MESSAGE_STATE;
     }

     return state;
}

const INITIAL_SERVER_ERROR_MESSAGE_STATE = {
     show: false,
     messages: [],
     statusCodes: [],
};

export function errorMessageReducer(
     state = INITIAL_SERVER_ERROR_MESSAGE_STATE,
     action,
) {
     switch (action.type) {
          case commonConstants.SHOW_ERROR_SERVER_MESSAGE:
               let messageList = [];
               let statusCodes;
               if (isArray(action.payload.message)) {
                    messageList = [...action.payload.message];
               } else {
                    messageList = [action.payload.message];
               }

               // if (typeof action.payload.statusCode != "undefined") {
               //      statusCodes = action.payload.statusCode;
               // }
               return {
                    ...state,
                    show: true,
                    messages: [...state.messages, ...messageList],
                    statusCodes: [
                         ...state.statusCodes,
                         action.payload.statusCode && action.payload.statusCode,
                    ],
               };

          case commonConstants.HIDE_ERROR_SERVER_MESSAGE:
               return INITIAL_SERVER_ERROR_MESSAGE_STATE;

          case commonConstants.HIDE_ERROR_CONFIRM_SERVER_MESSAGE:
               return INITIAL_SERVER_ERROR_MESSAGE_STATE;
     }

     return state;
}

const INITIAL_FRONTEND_MESSAGE_STATE = {
     show: false,
     title: null,
     message: null,
     icon: null,
     needAssistance: false,
     actionLabel: null,
     action: null,
};

export function frontEndMessageReducer(
     state = INITIAL_FRONTEND_MESSAGE_STATE,
     action,
) {
     switch (action.type) {
          case commonConstants.SHOW_FRONTEND_MESSAGE:
               return {
                    ...state,
                    show: true,
                    title: action.payload.title,
                    message: action.payload.message,
                    icon: action.payload.icon ? action.payload.icon : null,
                    needAssistance: action.payload.needAssistance
                         ? action.payload.needAssistance
                         : false,
                    actionLabel: action.payload.actionLabel,
                    redirectTo: action.payload.redirectTo,
               };

          case commonConstants.HIDE_FRONTEND_MESSAGE:
               return INITIAL_SERVER_ERROR_MESSAGE_STATE;
     }

     return state;
}
